import { INITIAL_VARIETIES_REQUEST, FETCH_VARIETIES_SUCCESS, FINAL_VARIETIES_REQUEST } from "../../types/maintainers/varieties.type";

const initialState = {
	customers: [],
	species: [],
	estates: [],
	categories: [],
	varieties: [],
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
};

function maintainers_varieties(state = initialState, action) {
	switch (action.type) {
		case INITIAL_VARIETIES_REQUEST:
			return {
				...state,
				isFetching: true,
			};
		case FETCH_VARIETIES_SUCCESS:
			return {
				...state,
				isFetching: false,
				customers: action.payload.customers,
				species: action.payload.species,
				estates: action.payload.estates,
				categories: action.payload.categories,
				varieties: action.payload.varieties,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		case FINAL_VARIETIES_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		default:
			return state;
	}
}

export default maintainers_varieties;
